import { get, logError } from 'utils';

export default function getAggregatorsList(
  onSuccess = (_list = []) => {},
  onError = () => {},
  onFinally = () => {}
) {
  get({ apiKey: 'configure.aggregator.list' })
    .then(({ data }) => onSuccess(Array.isArray(data) ? data : []))
    .catch(error => {
      logError(error, { customMessage: 'Fetch aggregators list failed' });
      onError(error);
    })
    .finally(onFinally);
}
